import { useState, useCallback } from 'react';
import axios from 'axios';

/**
 * Un hook personnalisé pour effectuer des requêtes DELETE.
 *
 * @param {string} url L'URL vers laquelle effectuer la requête DELETE.
 * @param {Id} toDelete L'id de l'enregistrement à supprimer
 * @returns {Object} Un objet contenant les données, l'état de chargement, et une éventuelle erreur.
 */
const useDelete = (deleteDataFunction, toDelete) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState(null);
  const [isDeleted, setIsDeleted] = useState(false);

  const deleteData = useCallback(async () => {
    setIsDeleting(true);
    try {
      await deleteDataFunction(toDelete);
      //await axios.delete(url, toDelete);
      setIsDeleted(true); // Marquer comme supprimé si la requête est réussie
    } catch (err) {
      setError({ message: err.response?.data?.error || 'An error occurred', status: err.message });
    } finally {
      setIsDeleting(false);
    }
  }, [toDelete]);

  // Exposez le statut de suppression, l'erreur, et la fonction de suppression
  return { isDeleting, error, isDeleted, deleteData, setIsDeleted};
};

export default useDelete;